<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <!-- <img
          class="u-rounded u-bg-orange"
          src="@/assets/img/content/icon_dentist.svg"
        /> -->
        <!-- <div
          class="c-header u-bg-orange -contain-bottom"
          :style="{
            'background-image':
              'url(' + require('@/assets/img/content/icon_dentist.svg') + ')',
          }"
        >
          <img
            class="c-header__logo"
            src="@/assets/img/ztk_logo.svg"
            width="110"
          />
        </div> -->
        <Header
          class="u-bg-orange -contain-bottom"
          headline="Beste zahnmedizinische Versorgung - 14 x in Süd-Deutschland"
          :image="require('@/assets/img/content/icon_dentist.svg')"
          :logo="require('@/assets/img/ztk_logo.svg')"
          logoWidth="210"
          @openChat="openChat('ztkCard')"
        />
        <p class="ion-padding-top ion-hide-lg-up">
          <b>Beste zahnmedizinische Versorgung - 14 x in Süd-Deutschland</b>
        </p>
        <p>
          Die Zahnärztlichen Tageskliniken bieten eine ausführliche Beratung,
          individuelle Betreuung und umfangreiche Serviceleistungen:
        </p>
        <SpezialisierungenZTK />
        <ion-row>
          <ion-col>
            <ion-text color="primary">
              <ion-icon :src="require('@lib/assets/icons/info.svg')" />
              &nbsp;<b>Ihr Lachen hat Vorrang: </b>
            </ion-text>
            <!-- <ion-text>
              <p>
                Machen Sie den Roodie.Check und beantworten Sie ein paar Fragen
                zu Ihrer gesundheitlichen Situation, um Ihnen gezielt bei der
                Suche helfen zu können.
              </p>
              <p>
                Sie können aber auch gerne gleich direkt einen Termin buchen.
                Oder schicken Sie einfach eine Terminanfrage und Sie werden
                umgehend kontaktiert, um einen Termin in einer Praxis vor Ort
                mit Ihnen zu vereinbaren.
              </p>
            </ion-text> -->
          </ion-col>
        </ion-row>
        <!-- <ion-row class="ion-margin-bottom">
          <ion-col size="4">
            <div
              class="u-bg-orange u-color-white u-rounded ion-text-center u-xsmall"
              style="height:100%; cursor: pointer; padding: 16px 8px 16px 8px;"
              @click="
                $router.push({
                  name: 'home',
                  params: {
                    name: 'toothAppointment',
                    shouldShowPaintype: false,
                    from: 'ztkCard',
                    type: 'Termin anfragen',
                  },
                })
              "
            >
              <ion-icon
                style="font-size: 32px; margin-bottom: 10px"
                :icon="call"
                slot="start"
              ></ion-icon>
              <br />
              Termin anfragen
            </div>
          </ion-col>

          <ion-col size="4">
            <div
              class="u-bg-orange u-color-white u-rounded ion-text-center u-xsmall"
              style="height:100%; cursor: pointer; padding: 16px 8px 16px 8px;"
              @click="showMap = true"
            >
              <ion-icon
                style="font-size: 32px; margin-bottom: 10px"
                :src="require('@lib/assets/icons/icon_incoming.svg')"
                slot="start"
              ></ion-icon>
              <br />
              Termin buchen
            </div>
          </ion-col>
          <ion-col size="4">
            <div
              class="u-bg-orange u-color-white u-rounded ion-text-center u-xsmall"
              style="height:100%; cursor: pointer; padding: 16px 8px 16px 8px;"
              @click="openChat('ztkCard')"
            >
              <ion-icon
                style="font-size: 32px; margin-bottom: 10px"
                :src="require('@lib/assets/icons/roodie-white_orange.svg')"
                slot="start"
              ></ion-icon>
              <br />
              Roodie.Check starten
            </div>
          </ion-col>
        </ion-row> -->
        <!-- <ion-row class="ion-align-items-center">
          <ion-col>
            <ion-button
              size="small"
              fill="clear"
              class="ion-text-wrap ion-no-padding"
              @click="
                $router.push({
                  path: '/ztk/anleitung_notbot',
                })
              "
              >So funktioniert's&nbsp;
              <ion-icon :icon="helpCircle" />
            </ion-button>
          </ion-col>
        </ion-row> -->
        <!-- <div class="ion-margin-top">
          <img src="@/assets/img/ztk_logo.svg" width="180" />
        </div> -->
        <!-- <div class="c-cta">
          <ion-button
            v-if="from === 'secondopinion'"
            @click="openChat('ztkCard')"
            class="ion-text-wrap mt-5"
            >Jetzt Zweitmeinung einholen&nbsp;
            <ion-icon
              :src="require('@lib/assets/icons/roodie-white.svg')"
              slot="end"
            ></ion-icon>
          </ion-button>
          <ion-button
            v-else-if="from === 'specialist'"
            @click="openChat('ztkCard')"
            class="ion-text-wrap mt-5"
            >Jetzt Facharzt/Klinik suchen&nbsp;
            <ion-icon
              :src="require('@lib/assets/icons/roodie-white.svg')"
              slot="end"
            ></ion-icon>
          </ion-button>
          <ion-button v-else @click="openChat('ztkCard')" class="ion-text-wrap"
            >Jetzt Zahnarzt suchen&nbsp;
            <ion-icon
              :src="require('@lib/assets/icons/roodie-white.svg')"
              slot="end"
            ></ion-icon>
          </ion-button>
        </div> -->

        <!-- <ion-row class="ion-margin-top">
          <ion-col>
            <div
              class="c-nugget u-bg-orange"
              @click="
                $router.push({
                  name: 'ztk',
                  params: { from: 'zahnarzt' },
                })
              "
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/arag_vorteile.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                ARAG-Vorteile
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget u-bg-orange"
              @click="$router.push({ path: '/ztk/anleitung_notbot' })"
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/icon_roodie_call.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                So funktioniert's
              </div>
            </div>
          </ion-col>
          <ion-col class="ion-hide-md-down">
            <div
              class="c-nugget u-bg-orange"
              @click="
                $router.push({
                  name: 'home',
                  params: {
                    name: 'toothAppointment',
                    shouldShowPaintype: false,
                    from: 'ztkCard',
                    type: 'Termin anfragen',
                  },
                })
              "
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/browser-anfrage.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Termin anfragen
              </div>
            </div>
          </ion-col>
          <ion-col class="ion-hide-md-down">
            <div
              class="c-nugget u-bg-orange"
              @click="
                $router.push({
                  name: 'home',
                  params: {
                    name: 'toothAppointment',
                    shouldShowPaintype: false,
                    from: 'ztkCard',
                    type: 'Termin buchen',
                  },
                })
              "
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/browser-buchen.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Termin buchen
              </div>
            </div>
          </ion-col>
        </ion-row> -->

        <!-- <ion-row>
          <ion-col class="ion-no-padding">
            <ion-button
              @click="
                selectedCondition = {
                  name: 'tooth',
                  area: 'head-front',
                  type: '',
                  part: '',
                  deepPart: '',
                };
                showPaintype = false;
              "
              class="ion-text-wrap mt-5 u-small"
              >Termin buchen
              <roodie
                class="ion-margin-start"
                fillOuter="white"
                fillInner="#5e58be"
                :size="20"
            /></ion-button>
          </ion-col>
          <ion-col class="ion-no-padding">
            <ion-button
              @click="
                selectedCondition = {
                  name: 'tooth',
                  area: 'head-front',
                  type: '',
                  part: '',
                  deepPart: '',
                };
                showPaintype = false;
              "
              class="ion-text-wrap mt-5 u-small"
              >Termin anfragen
              <roodie
                class="ion-margin-start"
                fillOuter="white"
                fillInner="#5e58be"
                :size="20"
            /></ion-button>
          </ion-col>
        </ion-row> -->

        <ion-row>
          <ion-col>
            <!-- <div class="c-line"></div> -->
            <ion-text>
              <!-- <b>14 x in Süd-Deutschland: </b>
                <br /> -->
              Modernste Ausstattung, individuell auf Sie abgestimmte
              Behandlungskonzepte, und am wichtigsten: ein freundliches und
              kompetentes Team erwarten Sie.
            </ion-text>
            <p>
              Wählen Sie eine Zahnarztpraxis in Ihrer Nähe und buchen Sie gleich
              online oder telefonisch einen Termin.
            </p>
            <p>
              <!-- <img class="u-rounded" src="@/assets/img/content/map_14mal.png" /> -->
              <MapZTK
                class="u-rounded"
                :locations="locations"
                :center="center"
              />
            </p>
          </ion-col>
        </ion-row>

        <!-- <ion-row class="ion-margin-top ion-hide-md-up">
          <ion-col>
            <div
              class="c-nugget u-bg-orange"
              @click="
                $router.push({
                  name: 'home',
                  params: {
                    name: 'toothAppointment',
                    shouldShowPaintype: false,
                    from: 'ztkCard',
                    type: 'Termin anfragen',
                  },
                })
              "
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/browser-anfrage.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Termin anfragen
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget u-bg-orange"
              @click="
                $router.push({
                  name: 'home',
                  params: {
                    name: 'toothAppointment',
                    shouldShowPaintype: false,
                    from: 'ztkCard',
                    type: 'Termin buchen',
                  },
                })
              "
            >
              <div
                class="c-nugget__image"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/content/browser-buchen.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Termin buchen
              </div>
            </div>
          </ion-col>
        </ion-row> -->

        <!-- <ion-row class="ion-margin-top">
          <ion-col>
            <div
              class="c-nugget"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/nugget_arag_vorteile.png') +
                  ')',
              }"
              @click="
                $router.push({
                  name: 'ztk',
                  params: { from: 'zahnarzt' },
                })
              "
            >
              <div class="c-nugget__label">
                ARAG-Vorteile
              </div>
            </div>
          </ion-col>
          <ion-col>
            <div
              class="c-nugget"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/nugget_podcast.png') +
                  ')',
              }"
            >
              <div class="c-nugget__label">
                Podcast
              </div>
            </div>
          </ion-col>
        </ion-row> -->

        <div class="u-color-primary u-small">
          <ion-icon :src="require('@lib/assets/icons/info.svg')" />&nbsp;
          <span>
            Geben Sie in der Zahnarztpraxis an, dass Sie bei der ARAG
            krankenversichert sind. Damit können Sie den Service der direkten
            Abrechnung zwischen der Zahnarztpraxis und der ARAG nutzen. Sie
            müssen nicht in Vorleistung gehen.
          </span>
        </div>
      </ion-grid>
    </ion-content>
    <ion-modal
      :is-open="showMap"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showMap = false"
    >
      <ion-page>
        <div class="modal-content">
          <modal-close />
          <div class="ion-padding ion-text-center">
            <roodie fillOuter="#5E58BE" :expression="'happy'" />
            <h2>Bitte wählen Sie einen Standort.</h2>
          </div>
          <MapZTK :locations="locations" :center="center" />
        </div>
      </ion-page>
    </ion-modal>
  </ion-page>
</template>

<script>
import { chevronBack, helpCircle, call } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonModal,
  IonBackButton,
} from "@ionic/vue";
import SpezialisierungenZTK from "@/components/SpezialisierungenZTK";
import Header from "@/components/Header";
import { chat } from "@/mixins/chat";
import MapZTK from "@/components/MapZTK";
import ModalClose from "@lib/components/ModalClose";
import Roodie from "@lib/components/svg/Roodie";
import { ztkLocations } from "@/utils/basics";

export default {
  mixins: [chat],
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    IonText,
    SpezialisierungenZTK,
    Header,
    MapZTK,
    ModalClose,
    IonModal,
    Roodie,
    IonBackButton,
  },
  props: {
    from: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      // from: "",
      // window: window,
      showMap: false,
      center: { lat: 49.1922994, lng: 10.2650204 },
      locations: ztkLocations,
    };
  },
  // ionViewWillEnter() {
  //   this.from = this.$route?.params?.from;
  // },
  setup() {
    return {
      chevronBack,
      helpCircle,
      call,
    };
  },
};
</script>

<style lang="scss" scoped></style>
